import React, { useEffect } from 'react';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useAtom } from 'jotai';
import {
  Button,
  Stack,
  LinearProgress,
} from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { selectedTurnItem } from '../../shared/selected.turn.items';
import { selectedTurnBase } from '../../shared/selected.turn.base';
import { selectedDoctorAtom } from '../../shared/selected.doctor';
import { specialityServices } from '../../shared/speciality.service';
import { fetchService } from '../../adapaters/fetchService';
import { selectedDepartmentAtom } from '../../shared/selected.department';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

const TurnItems = ({
  turnBaseData,
  doctors,
  controlBtn_ref,
  setSteps
}) => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const [turnBase] = useAtom(selectedTurnBase);
  const [selectedTurn, setSelectedTurnItem] = useAtom(
    selectedTurnItem
  );
  const [, setSelectedDoctor] = useAtom(selectedDoctorAtom);

  const [, setSpecialityService] = useAtom(
    specialityServices
  );

  const [selectedDepartment] = useAtom(
    selectedDepartmentAtom
  );
  const [selectedDoctor] = useAtom(selectedDoctorAtom);

 


  useEffect(() => {
    setSelectedDoctor();
    setSelectedTurnItem();
  }, []);

  // console.log('TurnItems ==>', {
  //   setSpecialityService,
  //   selectedDepartment,
  //   selectedDoctor,
  // });

  // useEffect(() => {
  //   if (
  //     selectedTurn &&
  //     turnBase === 'speciality' &&
  //     doctors?.length === 1
  //   ) {
  //     fetchService(
  //       setSpecialityService,
  //       selectedDepartment,
  //       selectedDoctor?.doctor?.id
  //     );
  //   } else {
  //     setSelectedDoctor();
  //   }
  // }, [selectedTurn, turnBase, doctors]);


  


  useEffect(() => {
    if (selectedTurn) {
      controlBtn_ref.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [selectedTurn]);





  useEffect(()=>{
    
    if(turnBaseData){
     if(turnBase === 'service'){
       if(turnBaseData?.serviceBased?.length === 1){
         setSelectedTurnItem(turnBaseData?.serviceBased[0])
         setSteps(steps=>steps+1);
         return
       }
     }
     if(turnBase === "speciality"){
       if(turnBaseData?.specialityBased?.length === 1){
         setSelectedTurnItem(turnBaseData?.specialityBased[0])
         setSteps(steps=>steps+1);
         return
       }
     }
 
    }
  
 
   },[turnBase,turnBaseData])



  const DepartmentButton = (props) => {
    return (
      <Button
        variant="contained"
        fullWidth
        sx={{
          minHeight: '3.125em',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          userSelect: 'none',
          color:
            selectedTurn?.id === props?.el?.id
              ? `${themeColors.ColorSecondary} !important`
              : `${themeColors.ColorPrimary} !important`,

          backgroundColor:
            selectedTurn?.id === props?.el?.id
              ? `${themeColors.ColorPrimary} !important`
              : `${themeColors.ColorSecondary} !important`,
        }}
        onClick={() => {
          setSelectedTurnItem(props.el);
        }}
      >
        <p>{ArabicToPersian(props.el.label)}</p>
      </Button>
    );
  };

  return (
    <React.Fragment>
      <Stack
        gap=".5em"
        sx={{
          display: screenWidth > 1024 ? 'grid' : '',
          gridTemplateColumns: 'repeat(2,1fr)',
          gridTemplateAreas: '1fr',
          direction: 'rtl',
        }}
      >
        {turnBase === 'service' ? (
          turnBaseData?.serviceBased?.map((el) => (
            <DepartmentButton el={el} key={el.id} />
          ))
        ) : turnBase === 'speciality' ? (
          turnBaseData?.specialityBased?.map((el) => (
            <DepartmentButton el={el} key={el.id} />
          ))
        ) : (
          <LinearProgress />
        )}
      </Stack>
    </React.Fragment>
  );
};

export default TurnItems;
